export default __webpack_public_path__ + "static/media/R4.8c1ed662.png";